<template>
    <div class="bg-page w-full p-4 rounded-md shadow-md">
        <slot />
    </div>
</template>
